import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { takeWhile } from 'rxjs/operators';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';

@Component({
    selector: 'ngx-one-column-layout',
    styleUrls: ['./one-column.layout.scss'],
    template: `
        <nb-layout>
            <nb-layout-header fixed>
                <ngx-header></ngx-header>
            </nb-layout-header>

            <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive>
                <nb-sidebar-header *ngIf="user && user.authorityName">
                    <a href="#" nbButton status="success" class="btn break-word">
                        <h6 class="break-word">{{ user.authorityName }}</h6>
                    </a>
                </nb-sidebar-header>
                <ng-content select="nb-menu"></ng-content>
            </nb-sidebar>

            <nb-layout-column>
                <ng-content select="router-outlet"></ng-content>
            </nb-layout-column>

            <nb-layout-footer fixed>
                <ngx-footer></ngx-footer>
            </nb-layout-footer>

            <nb-sidebar class="settings-sidebar" tag="settings-sidebar" state="collapsed" [end]="true" [fixed]="true"> </nb-sidebar>
        </nb-layout>
    `,
})
export class OneColumnLayoutComponent implements OnDestroy, OnInit {
    private alive = true;

    user: any;
    currentTheme: string;

    constructor(protected themeService: NbThemeService, private authService: NbAuthService) {
        this.themeService
            .getJsTheme()
            .pipe(takeWhile(() => this.alive))
            .subscribe(theme => {
                this.currentTheme = theme.name;
            });
    }

    ngOnInit(): void {
        this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
            if (token.isValid()) {
                this.user = token.getPayload();
            }
        });
    }

    ngOnDestroy(): void {
        this.alive = false;
    }
}
